"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerStyles = void 0;
var _patternLibraryUtils = require("@site/pattern-library-utils");
const ContainerStyles = exports.ContainerStyles = `
height: auto;
width: 100%;
display: flex;

@media ${_patternLibraryUtils.deviceMax.mobileLg} {
  flex-direction: column;
}
`;